import { render, staticRenderFns } from "./slider.vue?vue&type=template&id=022ee1c1&scoped=true&"
import script from "./slider.vue?vue&type=script&lang=js&"
export * from "./slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022ee1c1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('022ee1c1')) {
      api.createRecord('022ee1c1', component.options)
    } else {
      api.reload('022ee1c1', component.options)
    }
    module.hot.accept("./slider.vue?vue&type=template&id=022ee1c1&scoped=true&", function () {
      api.rerender('022ee1c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormDesign/ItemConfig/slider.vue"
export default component.exports